import {Injectable} from '@angular/core';
import {HttpService} from "../service/httpservice";
import {AppVersion} from '@ionic-native/app-version';
import {File} from '@ionic-native/file';
import {FileTransfer, FileTransferObject} from '@ionic-native/file-transfer';
import {FileOpener} from '@ionic-native/file-opener';
import {PlatformUtils} from "../util/platformutils";
import {MsgUtils} from "../util/msgutils";
import {AlertController} from "ionic-angular";
import {APK_DOWNLOAD, CHECKLATESTVERSION,IOS_APPSTORE_URL} from "../config/serviceurl";
import {InAppBrowser} from "@ionic-native/in-app-browser";

@Injectable()
export class VersionService {

  constructor(private alertCtrl: AlertController, private transfer: FileTransfer,
              private appVersion: AppVersion, private file: File,
              private fileOpener: FileOpener, private msgUtils: MsgUtils,
              private platformUtils: PlatformUtils, private httpService: HttpService,
              private inAppBrower: InAppBrowser) {
  }

  /***
   * 获取当前版本号
   * @returns {Promise<string>}
   */
  getCurrentVersionNum(): Promise<string> {
    return new Promise((resolve) => {
      this.appVersion.getVersionNumber().then((value: string) => {
        resolve(value);
      });
    });
  }

  /***
   * 获取最新版本号
   * @returns {Promise<string>}
   */
  getLatestVersionNum(): Promise<string> {
    let latest = this.getCurrentVersionNum();
    let currentPlatform = '';
    if (this.platformUtils.isAndroid()) {
      currentPlatform = "android";
    } else if (this.platformUtils.isIos()) {
      currentPlatform = "ios";
    }
    let params = {'platform': currentPlatform};
    this.httpService.post2(CHECKLATESTVERSION, params)
      .then(anyObj => {
          if (currentPlatform == "android") {
            latest = anyObj.android_app_version;
          } else if (currentPlatform == "ios") {
            latest = anyObj.ios_app_version;
          }
        }
      );
    return latest;
  }

  /***
   * 检查更新
   * @param {boolean} isNotice 检测为最新版时，是否需要提示
   */
  checkUpdate(isNotice: boolean) {
    let currentPlatform = '';
    if (this.platformUtils.isAndroid()) {
      currentPlatform = "android";
    } else if (this.platformUtils.isIos()) {
      currentPlatform = "ios";
    }
    if(this.platformUtils.isAndroid() || this.platformUtils.isIos()){
      let params = {'platform': currentPlatform};
    this.httpService.post2(CHECKLATESTVERSION, params)
      .then(anyObj => {
        this.isNeedVersionUpdate(anyObj, isNotice)
      });
    }
    
  }

  isNeedVersionUpdate(anyObj, isNotice: boolean) {
   if(anyObj != null && anyObj != undefined){
    this.getCurrentVersionNum().then(result => {
      if (this.platformUtils.isAndroid()) {
        let latest = anyObj.android_app_version;
        //存储版本号
         this.storageVersionCode(result, latest);
        if (!!result && this.compareVersion(result, latest)) {
          this.isCompulsotyUpdate(latest, anyObj.android_is_compulsory);
        } else {
          if (isNotice) {
            this.msgUtils.alert("", "当前已是最新版本！");
          }
        }
      } else if (this.platformUtils.isIos()) {
        let latest = anyObj.ios_app_version;
         this.storageVersionCode(result, latest);
        if (!!result && this.compareVersion(result, latest)) {
          this.isCompulsotyUpdate(latest, anyObj.ios_is_compulsory);
        } else {
          if (isNotice) {
            this.msgUtils.alert("", "当前已是最新版本！");
          }
        }
      }
    });
  }
  }

  /**
   * 比较当前版本号与最新版本号
   */
  compareVersion(currentVersion, latestVersion): boolean {
    console.log("当前version=" +currentVersion );
    let currVerArray = currentVersion.split(".");
    let latestVerArray = latestVersion.split(".");
    for (let i = 0; i < currVerArray.length; i++) {
      if (parseInt(currVerArray[i]) < parseInt(latestVerArray[i])) {
        return true;
      }else if (parseInt(currVerArray[i]) > parseInt(latestVerArray[i])){
        return false;
      }
    }
    return false;
  }

  /**
   * 区分是否强制更新
   */
  isCompulsotyUpdate(latestVersion, is_compulsory) {
    if (this.platformUtils.isMobile()) {
      if (is_compulsory == 'false') {
        //这里连接后台获取app最新版本号,然后与当前app版本号(this.getVersionNumber())对比
        //版本号不一样就需要申请,不需要升级就return
        let alert = this.alertCtrl.create({
          title: '升级',
          subTitle: '发现新版本,是否立即升级？',
          buttons: [
            {
              text: '确定',
              handler: () => {
                alert.onDidDismiss(() => {
                  this.downloadApp(latestVersion);
                })
              }
            }, {
              text: '取消'
            }
          ]
        });
        alert.present();
      } else {
        let alert = this.alertCtrl.create({
          title: '升级',
          subTitle: '有新版本,请立即升级！',
          buttons: [
            {
              text: '确定',
              handler: () => {
                alert.onDidDismiss(() => {
                  this.downloadApp(latestVersion);
                })
              }
            }
          ]
        });
        alert.present();
      }
    }
  }

  /**
   * 下载app[安卓]
   * 这里注意android7.0.0之后，对于文件路径会有保护，不能将file://URL暴露给app，则需要在config.xml文件配置android-targetSdkVersion属性为23
   * andriod7.0.0 对应SDK版本24
   * andriod6.0.0 对应SDK版本23
   */
  downloadApp(latestVersion) {
    if(this.platformUtils.isAndroid()) {
      const fileTransfer: FileTransferObject = this.transfer.create();
      const apk = this.file.externalDataDirectory + latestVersion + '.apk'; //apk保存的目录
      this.file.createDir(this.file.externalDataDirectory, "download", true).then(() => {
        let download = this.alertCtrl.create({
          title: '下载进度：0%',
          enableBackdropDismiss: true,
          buttons: [
            {
              text: '后台下载'
            }
          ]
        });
        download.present();
        fileTransfer.download(APK_DOWNLOAD + "/supwisdom" +  ".apk", apk).then(() => {
          this.fileOpener.open(apk, 'application/vnd.android.package-archive');
        });

        fileTransfer.onProgress((event: ProgressEvent) => {
          let num = Math.floor(event.loaded / event.total * 100);
          if (num == 100) {
            download.dismiss();
          } else {
            let title = document.getElementsByClassName('alert-title')[0];
            title && (title.innerHTML = '下载进度：' + num + '%');
          }
        });
      });
    }else if(this.platformUtils.isIos()){
      this.openUrlByBrowser(IOS_APPSTORE_URL);
    }
  }

  openUrlByBrowser(url:string){
     this.inAppBrower.create(url, "_system");
  }

  /**存储当前版本号和最新版本号 */
  storageVersionCode(currentVersionCode:any, latestVersionCode:any){
    localStorage.setItem("currentVersionCode", currentVersionCode);
    localStorage.setItem("latestVersionCode", latestVersionCode);
  }
}



// WEBPACK FOOTER //
// ./src/providers/util/versionservice.ts